import React, {useState} from 'react';
import ToggleableComponent from "@Generic/blocks/ToggleableComponent";
import datasetParser from "@Dataset/datasetParser";
import Translation from "@Translation/components/Translation";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

interface LeaveReviewButtonProps {
    index?: number,
}

function LeaveReviewButton({index}: LeaveReviewButtonProps) {
    const {stations} = datasetParser({className: 'write-review-box', index})
    const {locale, siteUrl} = useAppSelector((state) => state?.page)
    const gbbUrlReview = `${siteUrl}/${locale}/stop-review`
    const [display, toggleDisplay] = useState(false)

    return (
        <div className="dropdown dropdown-review-stations">
            <button
                className="btn btn-default btn--green dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => toggleDisplay(!display)}
            >
                <Translation translationKey="c_profile.write_a_review"/>
                <span className="caret"/>
            </button>
            <ToggleableComponent display={display}>
                <div style={{position: 'absolute', display: 'block'}} className="dropdown-menu">
                    {stations.map(({fullLangName, id}) => (
                        <li key={id}>
                            <a
                                className="dropdown-item gb--row"
                                href={`${gbbUrlReview}/${id}`}
                            >
                                {fullLangName}
                            </a>
                        </li>
                    ))}
                </div>
            </ToggleableComponent>
        </div>
    );
}

export default LeaveReviewButton